<div class="sticky top-0 header">
  <div class="flex flex-col-reverse full-width bg-surface -mt-2 border-b-2">
    <div class="mb-3">
      <soft-step-header [steps]="steps" [currentIndex]="2" #stepper></soft-step-header>
    </div>

    <soft-default-header
      [overline]="'Schritt 3 von 3'"
      [title]="stepper.current()?.header | translate"
      [subtitle]="stepper.current()?.subHeader | translate"
    ></soft-default-header>
  </div>
</div>

<div class="pb-20">
  <div class="soft-overline mt-4">
    {{'#INVENTUR.PAGES.ARTIKEL_AUSWAHL.MENGE' | translate}}
  </div>

  <div class="flex flex-col items-end justify-end w-full">
    @if (artikel(); as artikel) {
    <soft-mengen-eingabe
      class="mt-1 w-full"
      [value]="(artikel?.menge_inv ?? 0) > 0 ? (artikel.menge_inv ?? 0) : artikel.menge"
      [einheit]="artikel.einheit.arteh"
      [preventKeyboardEventEmission]="true"
      [float]="true"
      (valueChange)="onMengeChange($event)"
    ></soft-mengen-eingabe>
    <button class="soft-button link !p-0" (click)="openUnitEntryModal(artikel)">
      Mengeneingabe
    </button>
    }
  </div>
</div>
<button
  class="fixed left-0 right-0 bottom-0 soft-button primary w-full h-20 mt-16"
  (click)="onSubmit()"
  >
  {{'#INVENTUR.PAGES.ARTIKEL_AUSWAHL.SUBMIT' | translate}}
</button>

@if (loading$ | async) {
  <soft-blocking-loading-spinner
    class="top-0 right-0"
  ></soft-blocking-loading-spinner>
}
